const ACCEPTED_FILTERS_KEYS = [
  '5dias',
  'dateFrom',
  'dateTo',
  'id',
  'keyword',
  'myAreas',
  'myBid',
  'myFavorites',
  'myQuotes',
  'orderBy',
  'organization',
  'page',
  'priorized',
  'ocCanceladaEliminada',
  'region',
  'status'
]

/**
 * Search status purchase order.
 */
export const searchStatusPO = (selectedProviders, idState) => {
  if (!selectedProviders) return selectedProviders
  const search = Object.values(selectedProviders).some(selectedProvider =>
    selectedProvider?.purchaseOrder?.find(purchaseOrder => purchaseOrder.idState === idState)
  )
  return search
}

/**
 * Updates the given query object.
 */
export const updateQuery = (query, dictionary) => {
  Object.entries(dictionary)
    .filter(([key]) => ACCEPTED_FILTERS_KEYS.indexOf(key) !== -1)
    .reduce((collection, [key, value]) => {
      query.delete(key)

      if (value === '') {
        return collection
      }

      return collection.concat([[key, value]])
    }, [])
    .forEach(([key, value]) => query.set(key, value))
}
